var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "breadcrumb" },
        [_c("breadcrumb", { attrs: { breadcrumbConfig: _vm.dataList } })],
        1
      ),
      _c("div", { staticClass: "table" }, [
        _c(
          "div",
          { staticClass: "btnBox" },
          [
            _c(
              "el-form",
              {
                ref: "form",
                attrs: {
                  inline: true,
                  model: _vm.queryForm,
                  "label-width": "",
                  size: "mini",
                },
              },
              [
                _c("el-form-item", [
                  _c("div", { staticClass: "input-with-select" }, [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                          width: "210px",
                        },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticClass: "category-select",
                            staticStyle: { width: "90px" },
                            attrs: { placeholder: "选择分类", clearable: "" },
                            on: { change: _vm.handleCategoryTypeChange },
                            model: {
                              value: _vm.queryForm.categoryType,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryForm, "categoryType", $$v)
                              },
                              expression: "queryForm.categoryType",
                            },
                          },
                          _vm._l(_vm.categoryTypes, function (item) {
                            return _c("el-option", {
                              key: item.value,
                              staticClass: "category-option",
                              attrs: { label: item.label, value: item.value },
                            })
                          }),
                          1
                        ),
                        _c(
                          "el-select",
                          {
                            staticClass: "value-select",
                            staticStyle: { width: "120px" },
                            attrs: { placeholder: "选择值", clearable: "" },
                            model: {
                              value: _vm.queryForm.categoryValue,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryForm, "categoryValue", $$v)
                              },
                              expression: "queryForm.categoryValue",
                            },
                          },
                          _vm._l(_vm.currentCategoryValues, function (item) {
                            return _c("el-option", {
                              key: item.dictId,
                              staticClass: "value-option",
                              attrs: {
                                label: item.dictName,
                                value: item.dictId,
                              },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                ]),
                _c("el-form-item", [
                  _c("div", { staticClass: "input-with-select" }, [
                    _c(
                      "div",
                      { staticClass: "input-with-select" },
                      [
                        _c("span", { staticClass: "prepend-text" }, [
                          _vm._v("供应商名称"),
                        ]),
                        _c("el-input", {
                          attrs: { placeholder: "请输入" },
                          model: {
                            value: _vm.queryForm.goodName,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryForm, "goodName", $$v)
                            },
                            expression: "queryForm.goodName",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]),
                _c("el-form-item", [
                  _c(
                    "div",
                    { staticClass: "input-with-select" },
                    [
                      _c("span", { staticClass: "prepend-text" }, [
                        _vm._v("申请单号"),
                      ]),
                      _c("el-input", {
                        attrs: { placeholder: "请输入" },
                        model: {
                          value: _vm.queryForm.info,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryForm, "info", $$v)
                          },
                          expression: "queryForm.info",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _c("el-form-item", [
                  _c(
                    "div",
                    { staticClass: "input-with-select" },
                    [
                      _c("span", { staticClass: "prepend-text" }, [
                        _vm._v("联系电话"),
                      ]),
                      _c("el-input", {
                        attrs: { placeholder: "请输入" },
                        model: {
                          value: _vm.queryForm.supplierContactNumber,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.queryForm,
                              "supplierContactNumber",
                              $$v
                            )
                          },
                          expression: "queryForm.supplierContactNumber",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _c("el-form-item", [
                  _c(
                    "div",
                    { staticClass: "input-with-select" },
                    [
                      _c("span", { staticClass: "prepend-text" }, [
                        _vm._v("采购商品"),
                      ]),
                      _c("el-input", {
                        attrs: { placeholder: "请输入" },
                        model: {
                          value: _vm.queryForm.brand,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryForm, "brand", $$v)
                          },
                          expression: "queryForm.brand",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _c("el-form-item", [
                  _c(
                    "div",
                    { staticClass: "input-with-select" },
                    [
                      _c("span", { staticClass: "prepend-text" }, [
                        _vm._v("采购员"),
                      ]),
                      _c(
                        "el-select",
                        {
                          staticClass: "select-u",
                          attrs: {
                            placeholder: "请选择接收人员",
                            "collapse-tags": "",
                            multiple: "",
                            "popper-class": "hidden",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.openUserPicker.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryForm.purchaserId,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryForm, "purchaserId", $$v)
                            },
                            expression: "queryForm.purchaserId",
                          },
                        },
                        _vm._l(
                          _vm.queryForm.purchaserId,
                          function (user, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: { label: user.name, value: user },
                            })
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _c("el-form-item", [
                  _c(
                    "div",
                    { staticClass: "input-with-select" },
                    [
                      _c("span", { staticClass: "prepend-text" }, [
                        _vm._v("采购类型"),
                      ]),
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: "请选择",
                            clearable: "",
                            "default-first-option": "",
                          },
                          model: {
                            value: _vm.queryForm.purchaseType,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryForm, "purchaseType", $$v)
                            },
                            expression: "queryForm.purchaseType",
                          },
                        },
                        _vm._l(
                          _vm.dictionaries.purchase_type,
                          function (items, index) {
                            return _c("el-option", {
                              key: items.dictId,
                              attrs: {
                                label: items.dictName,
                                value: items.dictId,
                              },
                            })
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "mini" },
                        on: {
                          click: function ($event) {
                            return _vm.searchEvent()
                          },
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            return _vm.searchEvent.apply(null, arguments)
                          },
                        },
                      },
                      [_vm._v("查询")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { plain: "", size: "mini" },
                        on: { click: _vm.reset },
                      },
                      [_vm._v("重置")]
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    staticClass: "form-buttons",
                    staticStyle: { width: "100%" },
                  },
                  [
                    _c("div", { staticClass: "button-container" }, [
                      _c(
                        "div",
                        { staticClass: "button-group left-group" },
                        [
                          _vm.parArray.indexOf("purchaseFormList-add") != -1
                            ? _c(
                                "el-button",
                                {
                                  staticStyle: { "background-color": "#fff" },
                                  attrs: { plain: "", size: "mini" },
                                  on: { click: _vm.handleAdd },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "align-items": "center",
                                      },
                                    },
                                    [_vm._v(" 新增采购订单 ")]
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm.parArray.indexOf("purchaseFormList-export") != -1
                            ? _c(
                                "el-dropdown",
                                { on: { command: _vm.handleExportCommand } },
                                [
                                  _c(
                                    "el-button",
                                    { attrs: { plain: "", size: "mini" } },
                                    [
                                      _vm._v(" 导 出"),
                                      _c("i", {
                                        staticClass:
                                          "el-icon-arrow-down el-icon--right",
                                      }),
                                    ]
                                  ),
                                  _c(
                                    "el-dropdown-menu",
                                    {
                                      attrs: { slot: "dropdown" },
                                      slot: "dropdown",
                                    },
                                    [
                                      _c(
                                        "el-dropdown-item",
                                        { attrs: { command: "exportAll" } },
                                        [_vm._v(" 导出列表 ")]
                                      ),
                                      _c(
                                        "el-dropdown-item",
                                        {
                                          class: {
                                            "is-disabled": !_vm.hasSelection,
                                          },
                                          attrs: {
                                            disabled: !_vm.hasSelection,
                                            command: "exportSelected",
                                          },
                                        },
                                        [_vm._v(" 导出本页勾选的数据 ")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "button-group right-group" },
                        [
                          _c(
                            "el-checkbox",
                            {
                              on: { change: _vm.handleAutoRefreshChange },
                              model: {
                                value: _vm.autoRefresh,
                                callback: function ($$v) {
                                  _vm.autoRefresh = $$v
                                },
                                expression: "autoRefresh",
                              },
                            },
                            [_vm._v(" 自动刷新页面 ")]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            staticStyle: {
              padding: "0 10px",
              "background-color": "#fff",
              margin: "0 -10px",
            },
          },
          [
            _c("lb-table", {
              directives: [
                {
                  name: "horizontal-scroll",
                  rawName: "v-horizontal-scroll",
                  value: "always",
                  expression: '"always"',
                },
              ],
              attrs: {
                border: "",
                column: _vm.columns,
                align: "center",
                data: _vm.tableData.list,
                pagination: "",
                total: _vm.page.totalNum,
                layout: "total, sizes, prev, pager, next, jumper",
                "page-sizes": [5, 10, 20, 30, 50, 200],
                "current-page": _vm.page.currentPage,
                "page-size": _vm.page.pageSize,
                orderStatistics: _vm.page.totalNum,
                statisticText: "当前列表统计总采购订单数",
              },
              on: {
                "update:currentPage": function ($event) {
                  return _vm.$set(_vm.page, "currentPage", $event)
                },
                "update:current-page": function ($event) {
                  return _vm.$set(_vm.page, "currentPage", $event)
                },
                "size-change": _vm.handleSizeChange,
                "p-current-change": _vm.handleCurrentChange,
                refresh: _vm.fetchData,
                "selection-change": _vm.handleSelectionChange,
              },
            }),
          ],
          1
        ),
      ]),
      _c("purchase-order-dialog", {
        attrs: {
          visible: _vm.dialogVisible,
          type: _vm.dialogType,
          "form-data": _vm.formLabel,
          "supplier-options": _vm.supplierOptions,
        },
        on: {
          "update:visible": function ($event) {
            _vm.dialogVisible = $event
          },
          submit: _vm.handleOrderSubmit,
          closed: _vm.resetForm,
          success: _vm.handleOrderSuccess,
        },
      }),
      _c("org-picker", {
        ref: "orgPicker",
        attrs: { title: "接收人员", multiple: true },
        on: { ok: _vm.selectedUser },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }